/** ROS 2 `/hardware/set_security_module` — `controlboard_interfaces/srv/SetSecurityModule` */

import { LightState } from "lib/consts/ARC/light";

export const SECURITY_MODULE_SERVICE = "/hardware/set_security_module";
export const SECURITY_MODULE_SERVICE_TYPE =
    "controlboard_interfaces/srv/SetSecurityModule";
export const SECURITY_MODULE_TOPIC = "/hardware/security_module";
export const SECURITY_MODULE_TOPIC_TYPE = "std_msgs/String";

/**
 * @param {boolean} spotlight
 * @param {boolean} flash
 * @returns {[string, { spotlight: boolean, flash: boolean }, { serviceType: string }]}
 */
export const setSecurityModule = (spotlight, flash) => [
    SECURITY_MODULE_SERVICE,
    { spotlight, flash },
    { serviceType: SECURITY_MODULE_SERVICE_TYPE },
];

/**
 * @param {unknown} msg
 * @returns {{ spotlight: boolean, flash: boolean, connected: boolean } | null}
 */
export const parseSecurityModuleTopicPayload = (msg) => {
    try {
        let payload = msg;
        if (typeof msg === "string") {
            payload = JSON.parse(msg);
        } else if (msg != null && typeof msg === "object") {
            const record = /** @type {Record<string, unknown>} */ (msg);
            const raw = record.data;
            if (typeof raw === "string") {
                payload = JSON.parse(raw);
            } else if (raw != null && typeof raw === "object") {
                payload = raw;
            }
        }
        if (payload == null || typeof payload !== "object") {
            return null;
        }
        const record = /** @type {Record<string, unknown>} */ (payload);
        const power = /** @type {Record<string, unknown>} */ (record.power);
        if (power == null || typeof power !== "object") {
            return null;
        }
        const toBoolean = (value) => value === true || value === 1 || value === "1";
        return {
            spotlight: toBoolean(power.spotlight),
            flash: toBoolean(power.flash),
            // Missing/false => not connected. Startup latch must not look online.
            connected: toBoolean(record.connected),
        };
    } catch {
        return null;
    }
};

/** @param {{ flash: boolean }} payload */
export const flashStateFromPayload = ({ flash }) =>
    flash ? LightState.ON : LightState.OFF;
